var _rect, _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcProgress(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 128,
    height: 128,
    rx: 64,
    fill: "url(#paint0_linear_1933_12432)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1933_12432)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 13,
    width: 128,
    height: 128,
    rx: 64,
    fill: "white",
    fillOpacity: 0.01,
    shapeRendering: "crispEdges"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0031 57.0031L93.4688 58.325C93.1875 58.4281 93 58.7 93 59C93 59.3 93.1875 59.5719 93.4688 59.675L97.0031 60.9969L98.325 64.5312C98.4281 64.8125 98.7 65 99 65C99.3 65 99.5719 64.8125 99.675 64.5312L100.997 60.9969L104.531 59.675C104.812 59.5719 105 59.3 105 59C105 58.7 104.812 58.4281 104.531 58.325L100.997 57.0031L99.675 53.4688C99.5719 53.1875 99.3 53 99 53C98.7 53 98.4281 53.1875 98.325 53.4688L97.0031 57.0031ZM79.3219 90.0687C77.5688 91.8219 77.5688 94.6719 79.3219 96.4344L82.5656 99.6781C84.3188 101.431 87.1687 101.431 88.9312 99.6781L124.678 63.9219C126.431 62.1687 126.431 59.3188 124.678 57.5563L121.434 54.3219C119.681 52.5688 116.831 52.5688 115.069 54.3219L79.3219 90.0687ZM120.431 60.7438L110.588 70.5875L108.403 68.4031L118.247 58.5594L120.431 60.7438ZM75.7031 63.9875C75.2812 64.1469 75 64.55 75 65C75 65.45 75.2812 65.8531 75.7031 66.0125L81 68L82.9875 73.2969C83.1469 73.7188 83.55 74 84 74Cnan nan 84.8531 73.7188 85.0125 73.2969L87 68L92.2969 66.0125C92.7188 65.8531 93 65.45 93 65Cnan nan 92.7188 64.1469 92.2969 63.9875L87 62L85.0125 56.7031C84.8531 56.2812 84.45 56 84 56C83.55 56 83.1469 56.2812 82.9875 56.7031L81 62L75.7031 63.9875ZM108.703 87.9875C108.281 88.1469 108 88.55 108 89Cnan nan 108.281 89.8531 108.703 90.0125L114 92L115.987 97.2969C116.147 97.7188 116.55 98 117 98Cnan nan 117.853 97.7188 118.013 97.2969L120 92L125.297 90.0125C125.719 89.8531 126 89.45 126 89Cnan nan 125.719 88.1469 125.297 87.9875L120 86L118.013 80.7031C117.853 80.2812 117.45 80 117 80Cnan nan 116.147 80.2812 115.987 80.7031L114 86L108.703 87.9875Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1933_12432",
    x: 0,
    y: 0,
    width: 204,
    height: 204,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 12,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1933_12432"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 25
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1933_12432"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1933_12432",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1933_12432",
    x1: 38,
    y1: 13,
    x2: 166,
    y2: 141,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9333EA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProgress);
export default __webpack_public_path__ + "static/media/ic_progress.e1a6f6809bd9cd1d7ec9c35970fba1be.svg";
export { ForwardRef as ReactComponent };